import { BrandingStyle, DisabledPrompt, Link, useModel } from "@bcm-dev/bcms-vite";
import React from "react";
import CopyrightView from "../CopyrightView";
import "./styles.css";
import "./mobile.css";


/**
 * @function PageFooterView
 * @returns {React.Component}
 * @example
 * <PageFooterView text="FDIC Insured | Copyright 20XX">
 *  <p>This is inside the page footer.</p>
 * </PageFooterView>
 */
export default function PageFooterView(props) {
  const branding = useModel().branding.options;

  // Create all footer links based on what is set in branding
  const links = branding.footer_links_abi22.split(", ")
    .map((link, index) => <FooterLink key={ `Link_${ index }` } label={ link } />, []);
  // Get the message set in branding for the footer
  const text = branding.footer_message_abi22;

  return (
    <BrandingStyle style={{
                    "backgroundColor" : "footer_bg_abi22",
                    "borderColor" : "[[footer_hightlight_bar_abi22]]" }} className="page-footer-view text-center flex-container flex-vertical">

        <div className="flex-container flex-horizontal all-center link-container">
          { links }
        </div>
        <BrandingStyle style= {{ "color" : "[[footer_text_abi22]]"}} className="flex-height flex-container flex-horizontal all-center text-container">
          <div dangerouslySetInnerHTML={{ __html: text }} className="flex-container flex-horizontal align-center" />
        </BrandingStyle>
        <CopyrightView/>
    </BrandingStyle>
    
  );
}

/**
 * @function FooterLink
 * @param {STRING} label - Sets the text of the link
 * @returns {React.Component}
 * @description Disabled link to use to map over links set in branding
 * @example
 * <FooterLink label="Test" />
 */
function FooterLink({ label }) {
  return (
    <DisabledPrompt>
      <Link to="/">{ label }</Link>
    </DisabledPrompt>
  );
}